import { Button } from '@ds';
import { v4 as uuidV4 } from 'uuid';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { FormLinkDescriptionElement } from '@ui';
import { CaseFormType, MAX_LINK_DESCRIPTION_LENGTH } from '@features/forms/CaseForms/schema';
import { FormRow } from './FormRow';
import { CaseLinkType } from '@/api/apis/case';

export const CaseLinksBlock = ({ disabled }: { disabled?: boolean }) => {
  const { control, trigger } = useFormContext<CaseFormType>();
  const { fields, append, remove } = useFieldArray<CaseFormType>({
    control,
    name: 'links',
  });
  const links = fields as CaseLinkType[];

  const addLink = () => {
    const newLink: CaseLinkType = { id: uuidV4(), url: '', description: '', isNew: true };
    append(newLink);
  };

  const handleRemoveLink = (index: number) => {
    remove(index);
    trigger('links');
  };

  return (
    <FormRow title="Links" multiRow>
      <div className="flex flex-col w-full gap-2">
        {links.map((linkData: CaseLinkType, index) => (
          <FormLinkDescriptionElement
            key={linkData.id}
            index={index}
            formFieldName="links"
            handleDelete={() => handleRemoveLink(index)}
            disabled={disabled}
            maxLength={MAX_LINK_DESCRIPTION_LENGTH}
          />
        ))}
        {links.length < 10 && (
          <div>
            <Button
              isDisabled={disabled}
              onClick={addLink}
              className="text-xs-sb! w-20 h-6"
              size="sm"
              variant="outline"
            >
              + Add Link
            </Button>
          </div>
        )}
      </div>
    </FormRow>
  );
};
